const mapElements = document.querySelectorAll(
	'.block-location-franchises__map .state, .block-location-franchises__map .label'
);

const clickMapElement = (e) => {
	let mapElement;

	if (e.currentTarget) {
		e.preventDefault();
		mapElement = e.currentTarget;
	} else {
		mapElement = e;
	}

	if (
		!mapElement.hasAttribute('data-abbreviation') ||
		!mapElement.hasAttribute('data-name')
	) {
		return;
	}
	const block = mapElement.closest('.block-location-franchises');

	if (!block) {
		return;
	}

	const stateAbbreviation = mapElement.getAttribute('data-abbreviation');

	const accordionContents = block.querySelector(
		`.block-location-franchises__accordion-content[data-abbreviation="${stateAbbreviation}"]`
	);

	if (!accordionContents) {
		return;
	}

	const stateName = mapElement.getAttribute('data-name');

	const lightboxCta = block.querySelector(
		'.block-location-franchises__lightbox-cta-wrapper'
	);
	let lightboxCtaHTML = '';

	if (lightboxCta) {
		lightboxCtaHTML = lightboxCta.innerHTML;
	}

	const openLightboxEvent = new CustomEvent('propel-open-lightbox', {
		detail: {
			content: `<div class="block-location-franchises__lightbox-content"><h2>${stateName}</h2>${accordionContents.innerHTML}${lightboxCtaHTML}</div>`,
		},
	});
	window.dispatchEvent(openLightboxEvent);
};

if (mapElements.length > 0) {
	mapElements.forEach((mapElement) => {
		mapElement.addEventListener('click', clickMapElement);

		mapElement.addEventListener('keydown', (e) => {
			if (e.key !== 'Enter' && e.key !== ' ') {
				return;
			}

			e.preventDefault();

			clickMapElement(e.currentTarget);
		});
	});
}
